import { render, staticRenderFns } from "./noticeAdd.vue?vue&type=template&id=3c8da6c8&scoped=true&"
import script from "./noticeAdd.vue?vue&type=script&lang=js&"
export * from "./noticeAdd.vue?vue&type=script&lang=js&"
import style0 from "./noticeAdd.vue?vue&type=style&index=0&id=3c8da6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8da6c8",
  null
  
)

export default component.exports